import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { Button, type ButtonProps } from "@/components/ui/button";
import { Tooltip } from "@/components/ui/tooltip";
import { useCopy } from "@/lib/hooks";
import { t } from "@/i18n/id";

export function CopyButton({ value, label = t.common.copy, iconOnly, size = "sm", variant = "secondary", toastMessage }: { value: string; label?: string; iconOnly?: boolean; toastMessage?: string } & Pick<ButtonProps, "size" | "variant">) {
  const [copied, copy] = useCopy();
  const onClick = async () => {
    if (await copy(value)) toast.success(toastMessage ?? t.common.copied);
  };
  const icon = copied ? <Check aria-hidden="true" /> : <Copy aria-hidden="true" />;
  if (iconOnly) {
    return (
      <Tooltip content={copied ? t.common.copied : label}>
        <Button variant={variant === "secondary" ? "ghost" : variant} size={size === "sm" ? "icon-sm" : "icon"} onClick={onClick} aria-label={label}>
          {icon}
        </Button>
      </Tooltip>
    );
  }
  return (
    <Button variant={variant} size={size} onClick={onClick} leftIcon={icon}>
      {copied ? t.common.copied : label}
    </Button>
  );
}
